// extracted by mini-css-extract-plugin
export default {"discountWrapper":"DiscountFooter-common-module__discountWrapper___1ZvYU"};